const reducer = state => ({
  ...state,
  loaded: false,
  waiting: true,
});

export default reducer;
